import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';

const fadeInUp = {
  hidden: { opacity: 0, y: 24 },
  show: { opacity: 1, y: 0, transition: { duration: 0.5, ease: 'easeOut' } },
};

const HeroAbout = () => {
  const stats = [
    { value: '2025', label: 'Founded', accent: 'from-clay-500 to-clay-600' },
    { value: '50+', label: 'Products', accent: 'from-saffron-500 to-saffron-600' },
    { value: '10+', label: 'Artisans', accent: 'from-rose-500 to-rose-600' },
    { value: '100%', label: 'Authentic', accent: 'from-green-500 to-green-600' },
  ];

  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-cream-100 via-cream-50 to-white py-16 md:py-24">
      {/* Decorative blobs */}
      <div className="absolute -top-24 -right-24 w-96 h-96 bg-saffron-200/40 rounded-full blur-3xl animate-pulse-soft"></div>
      <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-clay-200/40 rounded-full blur-3xl animate-pulse-soft"></div>

      <motion.div
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.3 }}
        variants={fadeInUp}
        className="relative container mx-auto px-4"
      >
        <div className="max-w-4xl mx-auto text-center">
          <span className="inline-flex items-center gap-2 px-4 py-2 bg-white/70 backdrop-blur-md text-clay-600 border border-cream-200 rounded-full mb-6 shadow-sm">
            <Sparkles className="w-4 h-4" />
            Our Story
          </span>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight text-cocoa-900">
            About{' '}
            <span className="font-bengali text-gradient-warm">তন্তিকা</span>
          </h1>

          <p className="text-lg md:text-xl text-cocoa-600 mb-10 max-w-3xl mx-auto">
            তন্তিকা is more than just an ecommerce platform. We are a bridge connecting the rich heritage
            of Bengali craftsmanship with modern consumers who appreciate authenticity and quality.
          </p>

          {/* Stats */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 max-w-3xl mx-auto mt-6">
            {stats.map((stat, index) => (
              <motion.div
                key={stat.label}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ duration: 0.5, delay: index * 0.08 }}
                className="relative overflow-hidden bg-white p-6 rounded-2xl shadow-sm border border-cream-200 hover:shadow-warm transition-shadow"
              >
                <div className={`absolute top-0 left-0 right-0 h-1 bg-gradient-to-r ${stat.accent}`}></div>
                <div className={`text-3xl font-bold bg-gradient-to-r ${stat.accent} bg-clip-text text-transparent`}>
                  {stat.value}
                </div>
                <div className="text-cocoa-600 mt-1">{stat.label}</div>
              </motion.div>
            ))}
          </div>
        </div>
      </motion.div>
    </section>
  );
};

export default HeroAbout;
